import { ThumbnailCardListCombinedProps } from './types';

const usePresenter = (props: ThumbnailCardListCombinedProps): ThumbnailCardListCombinedProps => {
  return props;
};

export default usePresenter;
